import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useRealtime } from '@/hooks/use-realtime'
import { TaskActionsProvider } from '@/features/tasks/task-actions'
import { Sidebar } from './sidebar'
import { Topbar } from './topbar'
import { CommandPalette } from './command-palette'

/** Parallax do fundo: o mesh acompanha o mouse suavemente. */
function useBackgroundParallax() {
  useEffect(() => {
    let raf = 0
    const onMove = (e: MouseEvent) => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(() => {
        const x = e.clientX / window.innerWidth - 0.5
        const y = e.clientY / window.innerHeight - 0.5
        document.documentElement.style.setProperty('--mx', String(x))
        document.documentElement.style.setProperty('--my', String(y))
      })
    }
    window.addEventListener('mousemove', onMove, { passive: true })
    return () => {
      window.removeEventListener('mousemove', onMove)
      cancelAnimationFrame(raf)
    }
  }, [])
}

export function AppLayout() {
  useRealtime()
  useBackgroundParallax()
  const location = useLocation()
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const [paletteOpen, setPaletteOpen] = useState(false)

  return (
    <TaskActionsProvider>
      <div className="flex h-full">
        <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />

        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar
            onOpenMobileNav={() => setMobileNavOpen(true)}
            onOpenPalette={() => setPaletteOpen(true)}
          />
          <main className="flex-1 overflow-y-auto">
            <div
              key={location.pathname}
              className="mx-auto w-full max-w-7xl animate-reveal p-4 sm:p-6"
            >
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
    </TaskActionsProvider>
  )
}
